import {get} from "@/plugins/request";

export function listSubNavs() {
  return get("/v1/nav/productions")
}

export function getSliders() {
  return get("/v1/nav/sliders")
}